import apiClient from './apiClient';

/**
 * Contact-channel API client.
 *
 * Two surfaces share this module — the user-facing endpoints under
 * /api/v1.0/contact/* and the operator inbox under
 * /api/v1.0/operator/contact/*. The JWT and X-Org-Id headers are
 * attached by the shared interceptor in apiClient, so callers don't
 * need to think about auth.
 */

const userBase = '/api/v1.0/contact';
const opBase = '/api/v1.0/operator/contact';

// ---- user-facing -----------------------------------------------

export const submitTicket = (payload) =>
  apiClient.post(`${userBase}/tickets`, payload).then((r) => r.data);

export const listMyTickets = () =>
  apiClient.get(`${userBase}/tickets`).then((r) => r.data);

export const getMyTicket = (id) =>
  apiClient.get(`${userBase}/tickets/${id}`).then((r) => r.data);

export const replyToMyTicket = (id, body) =>
  apiClient.post(`${userBase}/tickets/${id}/replies`, { body }).then((r) => r.data);

export const resolveMyTicket = (id) =>
  apiClient.post(`${userBase}/tickets/${id}/resolve`).then((r) => r.data);

// ---- operator-facing -------------------------------------------

export const fetchOperatorInbox = () =>
  apiClient.get(`${opBase}/inbox`).then((r) => r.data);

export const fetchOperatorTicket = (id) =>
  apiClient.get(`${opBase}/tickets/${id}`).then((r) => r.data);

export const replyAsOperator = (id, body, setStatus) =>
  apiClient.post(`${opBase}/tickets/${id}/replies`, { body, setStatus }).then((r) => r.data);

export const changeOperatorStatus = (id, status) =>
  apiClient.post(`${opBase}/tickets/${id}/status`, { status }).then((r) => r.data);

export const deleteOperatorTicket = (id) =>
  apiClient.delete(`${opBase}/tickets/${id}`).then((r) => r.data);

// ---- helpers ---------------------------------------------------

export const TICKET_TYPES = ['BUG', 'FEATURE', 'GENERAL'];
export const TICKET_STATUSES = ['OPEN', 'IN_PROGRESS', 'WAITING_USER', 'RESOLVED'];

export const TYPE_LABELS = {
  BUG: 'Bug report',
  FEATURE: 'Feature request',
  GENERAL: 'General contact',
};

export const STATUS_LABELS = {
  OPEN: 'Open',
  IN_PROGRESS: 'In progress',
  WAITING_USER: 'Waiting on you',
  RESOLVED: 'Resolved',
};

export const STATUS_COLORS = {
  OPEN: 'info',
  IN_PROGRESS: 'primary',
  WAITING_USER: 'warning',
  RESOLVED: 'success',
};
